<template>
  <li class="nav-item" style="cursor: pointer; position: relative">
    <a
      class="nav-link"
      id="link"
      @click="toggleDropdown"
      :class="{ show: isOpen }"
    >
      <div class="text ps-1">
        <span v-if="icon" v-html="icon" style="margin-right: 8px;" class="sidenav-icon" ></span>
        <span v-else-if="iconImg" style="margin-right: 8px">
          <img
            :src="iconImg"
            alt="icon"
            style="height: 18px; vertical-align: middle; margin-left: -20px;"
            class="text-sm"
          />
        </span>
        <span
          style="
            font-weight: 400;
            font-size: 15px;
            color: white !important;
            text-transform: capitalize;
          "
          class="text-light ms-1"
          >{{ title }}</span
        >
      </div>

      <i
        style="top: 14px; right: -5px; position: absolute"
        class="fas fa-chevron-down"
      ></i>
    </a>
    <div class="collapse" :class="{ show: isOpen }">
      <ul class="nav">
        <slot></slot>
      </ul>
    </div>
  </li>
</template>

<script>
export default {
  name: "SidenavDropdown",
  props: {
    title: String,
    icon: {
      type: String,
      default: "",
    },
    iconImg: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style>
#link {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sidenav-icon {
  font-size: 14px !important;
}
</style>
